import { Card, Flex, Text } from '@mantine/core'
import { ReactNode } from 'react'
import styles from './TutorPage.module.scss'

interface FindMyTutorPanelHeaderProps {
	title: string
	description: string
	controls: ReactNode
}

export default function FindMyTutorPanelHeader({
	title,
	description,
	controls,
}: FindMyTutorPanelHeaderProps) {
	return (
		<Card withBorder radius="md" p={0} className={styles.headerCard}>
			<Flex
				align="center"
				gap={14}
				wrap="wrap"
				className={styles.headerSummary}
			>
				<Text size="xs" fw={800} tt="uppercase" className={styles.eyebrow}>
					Find My Tutor
				</Text>
				<Text fw={800} size={20} className={styles.pageTitle}>
					{title}
				</Text>
				<span className={styles.headerDivider} aria-hidden="true" />
				<Text size="sm" color="dimmed" className={styles.headerDescription}>
					{description}
				</Text>
			</Flex>

			<div className={styles.filterRow}>{controls}</div>
		</Card>
	)
}
